/* eslint-disable import/no-cycle */
import {
  GetWhatsAppSettingsResponse,
  whatsAppApi,
} from '@src/reducers/whatsapp';
import { getUserCanReceiveCalls } from '@src/selectors/user';
import store from '@src/store/reduxstore';
import { callApiQuery } from '@src/utils/apiQueryHelper';
import { createAudioEl, removeAudioElById } from '@src/utils/audio';

const RINGTONE_ID = 'CALL_RINGTONE';
const RINGTONE_INCOMMING_URL =
  'https://s3.us-east-1.amazonaws.com/static.b2chat/shared/llamada_entrante.mp3';

const RINGTONE_OUTGOING_URL =
  'https://s3.us-east-1.amazonaws.com/static.b2chat/shared/llamada_saliente.mp3';

export const allowedPathsToPlayRingtone = ['/agent/chat'];

// eslint-disable-next-line no-shadow
export enum RingtoneType {
  INCOMING,
  OUTGOING,
}

export const startCallRingtone = async (type: RingtoneType): Promise<void> => {
  const state = store.getState();
  const canReceiveCalls = getUserCanReceiveCalls(state);

  if (
    !canReceiveCalls ||
    !allowedPathsToPlayRingtone.includes(window.location.pathname)
  )
    return;

  const data = await callApiQuery<GetWhatsAppSettingsResponse>(
    whatsAppApi.endpoints.getWhatsAppSettings
  );
  const { ringingEnabled = false } = data?.templateSettings || {};

  if (!ringingEnabled) return;

  const ringtoneEl = createAudioEl(RINGTONE_ID);
  ringtoneEl.loop = true;
  ringtoneEl.volume = 0.38;
  ringtoneEl.src =
    type === RingtoneType.INCOMING
      ? RINGTONE_INCOMMING_URL
      : RINGTONE_OUTGOING_URL;

  await new Promise(resolve => {
    ringtoneEl.addEventListener('canplaythrough', resolve, { once: true });
    ringtoneEl.addEventListener('error', resolve, { once: true });
  });

  ringtoneEl.play().catch(error => {
    if (error.name !== 'AbortError') {
      // eslint-disable-next-line no-console
      console.warn('Playback failed ringtone:', error);
    }
  });
};

export const stopCallRingtone = (): void => {
  removeAudioElById(RINGTONE_ID);
};
